
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ApiService from '@/core/services/ApiService';
import { ScrollComponent } from '@/assets/ts/components/_ScrollComponent';
import { MenuComponent } from '@/assets/ts/components/MenuComponent';
import { version } from '@/core/helpers/documentation';
import { asideMenuIcons } from '@/core/helpers/config';
import { VueCookieNext } from 'vue-cookie-next';
import { apiEndpoint } from '@/mixin/apiEndpoint';
//import MainMenuConfig from "./Menu";

export default defineComponent({
  mixins: [apiEndpoint],
  name: 'kt-menu',
  data() {
    return {
      loading: true,
      entity_type_name: '',
      MainMenuConfig: [
        {
          heading: 'menu',
          route: '/association',
          pages: [
            {
              sectionTitle: 'Entity',
              route: '/association/trainning-partner',
              svgIcon: 'media/icons/duotune/general/gen025.svg',
              fontIcon: 'bi-app-indicator',
              sub: [
                {
                  heading: 'Entity List',
                  route: '/association/entity-list',
                },
                {
                  heading: 'Add Entity',
                  route: '/association/new-entity',
                },
              ],
            },
            {
              heading: 'Training Partner Contracts',
              route: '/association/association-contracts',
              fontIcon: 'bi-dashboard',
              svgIcon: '/media/icons/duotune/general/gen026.svg',
            },
            {
              sectionTitle: 'Training Target',
              route: '/association/trainning-target',
              svgIcon: 'media/icons/duotune/general/gen025.svg',
              fontIcon: 'bi-app-indicator',
              sub: [
                {
                  heading: 'Training Target List',
                  route: '/association/target-list',
                },
                {
                  heading: 'Add Training Target',
                  route: '/association/entity-target',
                },
                {
                  heading: 'Pending Training Target',
                  route: '/association/pending-target',
                },
              ],
            },
          ],
        },
      ],
    };
  },
  async created() {
    await this.menucheck();
  },
  methods: {
    async menucheck() {
      let entity_type_id = VueCookieNext.getCookie('_seip_entity_type');
      console.log(entity_type_id);
      if (entity_type_id != 1004) {
        this.MainMenuConfig = [
          {
            heading: 'menu',
            route: '/association',
            pages: [
              {
                sectionTitle: 'Entity',
                route: '/association/trainning-partner',
                svgIcon: 'media/icons/duotune/general/gen025.svg',
                fontIcon: 'bi-app-indicator',
                sub: [
                  {
                    heading: 'Entity List',
                    route: '/association/entity-list',
                  },
                ],
              },
              {
                heading: 'Entity Contracts',
                route: '/association/association-contracts',
                fontIcon: 'bi-dashboard',
                svgIcon: '/media/icons/duotune/general/gen026.svg',
              },
              {
                sectionTitle: 'Training Target',
                route: '/association/trainning-target',
                svgIcon: 'media/icons/duotune/general/gen025.svg',
                fontIcon: 'bi-app-indicator',
                sub: [
                  {
                    heading: 'Training Target List',
                    route: '/association/target-list',
                  },
                  {
                    heading: 'Add Training Target',
                    route: '/association/entity-target',
                  },
                ],
              },
            ],
          },
        ];
      }
    },
  },

  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      asideMenuIcons,
      version,
      translate,
    };
  },
});
